import {Provider} from '@angular/core';
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {
    LgCalculationLogicTypeObjectComponent
} from "../component/object-components/calculation-logic-type-object-component/lg-calculation-logic-type-object.component";
import {
    LgCalculationLogicTypeStepComponent
} from "../component/object-components/calculation-logic-type-object-component/shared/calculation-logic-type-step-component/lg-calculation-logic-type-step.component";
import {
    LgCalculationTestCaseComponent
} from "../component/object-components/calculation-logic-type-object-component/shared/lg-calculation-test-case/lg-calculation-test-case.component";
import {LgLogicObjectComponent} from "../component/object-components/logic-object-component/lg-logic-object.component";
import {
    LgLogicObjectFullComponent
} from "../component/object-components/logic-object-component/view/lg-logic-object-component-full/lg-logic-object-full.component";
import {
    LgLogicObjectSideComponent
} from "../component/object-components/logic-object-component/view/lg-logic-object-component-side/lg-logic-object-side.component";
import {LgConfigPagePage} from "../page/lg-config-page/lg-config-page.page";
import {LgLogicPagePage} from "../page/lg-logic-page/lg-logic-page.page";
import {CodeEditorComponent} from "../component/protected-components/code-editor/code-editor.component";
import {LgTestCaseComponent} from "../component/protected-components/lg-test-case/lg-test-case.component";
import {LgVariablesComponent} from "../component/protected-components/lg-variables/lg-variables.component";
import {LgLogicPageComponent} from "../component/protected-components/logic-page-component/lg-logic-page.component";

const lgModuleEntry: TestModuleDefinition = {
    key: 'lg',
    label: 'Logics (lg)',
    components: [
        {
            key: 'codeEditorComponent',
            component: CodeEditorComponent,
            selector: 'app-code-editor',
            type: 'Component',
            label: 'Code Editor'
        },
        {
            key: 'lgTestCaseComponent',
            component: LgTestCaseComponent,
            selector: 'mvs-lg-test-case',
            type: 'Component',
            label: 'Test Case'
        },
        {
            key: 'lgVariablesComponent',
            component: LgVariablesComponent,
            selector: 'mvs-lg-variables',
            type: 'Component',
            label: 'Variables'
        },
        {
            key: 'lgLogicPageComponent',
            component: LgLogicPageComponent,
            selector: 'lg-logic-page-component',
            type: 'Component',
            label: 'Logic Page Component'
        },
        {
            key: 'lgCalculationLogicTypeStepComponent',
            component: LgCalculationLogicTypeStepComponent,
            selector: 'lg-calculation-logic-type-step-component',
            type: 'Component',
            label: 'Calculation Logic Step'
        },
        {
            key: 'lgCalculationTestCaseComponent',
            component: LgCalculationTestCaseComponent,
            selector: 'mvs-lg-calculation-test-case',
            type: 'Component',
            label: 'Calculation Test Case'
        },
        {
            key: 'lgCalculationLogicTypeObjectComponent',
            component: LgCalculationLogicTypeObjectComponent,
            selector: 'mvs-lg-calculation-logic-type-object-component',
            type: 'ObjectBaseComponent',
            label: 'Calculation Logic Type Object'
        },
        {
            key: 'lgLogicObjectComponent',
            component: LgLogicObjectComponent,
            selector: 'mvs-lg-logic-object-component',
            type: 'ObjectBaseComponent',
            label: 'Logic Object'
        },
        {
            key: 'lgLogicObjectFullComponent',
            component: LgLogicObjectFullComponent,
            selector: 'mvs-lg-logic-object-component-full',
            type: 'ObjectBaseComponent',
            label: 'Logic Object Full'
        },
        {
            key: 'lgLogicObjectSideComponent',
            component: LgLogicObjectSideComponent,
            selector: 'mvs-lg-logic-object-component-side',
            type: 'ObjectBaseComponent',
            label: 'Logic Object Side'
        },
        {
            key: 'LgConfigPagePage',
            component: LgConfigPagePage,
            selector: 'lg-config-page',
            type: 'PageComponent',
            label: 'Logic Config Page'
        },
        {
            key: 'LgLogicPagePage',
            component: LgLogicPagePage,
            selector: 'lg-logic-page',
            type: 'PageComponent',
            label: 'Logic Page'
        }
    ]
}

export const LG_TEST_PROVIDERS: Provider[] = [
    { provide: TEST_MODULE_REGISTRY, useValue: lgModuleEntry, multi: true }
];